import React, { useState } from 'react';
import CustomButton from './CustomButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DownloadIcon from '@mui/icons-material/Download'
import './PerguntasFrequentesSection.css';

const PerguntasFrequentesSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'Sou cliente: como começo?',
      answer: 'Baixe o app, cadastre seu pet e escolha um parceiro próximo no mapa. Agende seu primeiro banho em poucos segundos!'
    },
    {
      question: 'Sou parceiro: e se já tiver a agenda cheia?',
      answer: 'Sem problemas! Você controla sua agenda e pode definir seus horários disponíveis. A plataforma só mostra horários que você liberou.'
    },
    {
      question: 'Quanto custa para o parceiro?',
      answer: 'O custo é apenas o valor do repasse que você escolhe. Não há mensalidade nem taxas ocultas. Você só paga quando recebe um cliente através da plataforma.'
    },
    {
      question: 'Como funciona o pagamento?',
      answer: 'O pagamento é feito diretamente pelo app do cliente no momento do agendamento. Você recebe o valor após a validação do serviço via QR Code.'
    },
    {
      question: 'Posso cancelar um agendamento?',
      answer: 'Sim! Clientes podem cancelar agendamentos com até 24h de antecedência sem custo. Parceiros também podem ajustar sua disponibilidade conforme necessário.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="perguntas-frequentes-section">
      <div className="perguntas-frequentes-content">
        <h2 className="perguntas-frequentes-title">Perguntas Frequentes</h2>

        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div key={index} className="faq-item">
              <button
                className={`faq-question ${openIndex === index ? 'open' : ''}`}
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <ExpandMoreIcon
                  className={`faq-icon ${openIndex === index ? 'open' : ''}`}
                />
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="perguntas-frequentes-buttons">
          {/* <CustomButton
            variant="contained"
            customBackground="#46558D"
            sx={{
              borderColor: '#46558D',
              color: '#FFFFFF',
              padding: '14px 32px',
              fontSize: '16px',
              width: '200px',
              fontWeight: 600,
              '&:hover': {
                borderColor: '#3a4a75',
                backgroundColor: 'rgba(70, 85, 141, 0.04)',
                color: '#3a4a75',
              },
            }}
          >
            Baixe o app
          </CustomButton>
          <CustomButton
            variant="contained"
            sx={{
              backgroundColor: '#FF914D',
              color: '#FFFFFF',
              padding: '14px 32px',
              fontSize: '16px',
              width: '200px',
              fontWeight: 600,
              '&:hover': {
                backgroundColor: '#e67e3d',
              },
            }}
            onClick={() => navigate('/cadastro-parceiro')}
          >
            Seja parceiro
          </CustomButton> */}
          <CustomButton
            variant="contained"
            sx={{
              backgroundColor: '#FF914D',
              color: '#FFFFFF',
              padding: '12px 24px',
              fontSize: '15px',
              '&:hover': {
                backgroundColor: '#e67e3d',
              },
            }}
          >
            <DownloadIcon />
            Baixar para iOS
          </CustomButton>

          <CustomButton
            variant="contained"
            sx={{
              fontSize: '15px',
              padding: '12px 24px',
            }}
          >
            <DownloadIcon />
            Baixar para Android
          </CustomButton>
        </div>
      </div>
    </section>
  );
};

export default PerguntasFrequentesSection;

